import {AxiosError} from 'axios'

interface ErrorResponse {
    data?: object
}

export class UnknownError {
    static messageByAxiosError(reason: AxiosError<ErrorResponse>) {
        return 'Unknown Error: ' + JSON.stringify(reason.response?.data ?? 'There is no axios response.')
    }
}